import React, { useState, useLayoutEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

export default function Logout() {
  const navigate = useNavigate();
  useLayoutEffect(() => {
    localStorage.removeItem('email');
    localStorage.removeItem('region');
    window.location.href='/login';
  });
  return (<></>);
}
